import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import VideoConferenceNotificationsView from './unrouted-prescriptions-notifications-view';

import { NOTIFICATION_TYPE } from '../../../../constants';

import { fetchNotificationsRelatedData } from '../../../../helpers';

import stores from 'bootstrap/store';
import { goToReview } from './helpers';

const prescriptionFillsStore = stores.global.prescriptionFills;


const UnroutedPrescriptionsNotificationsContainer = () => {
  useEffect(() => {
    fetchNotificationsRelatedData(NOTIFICATION_TYPE.UN_ROUTED_PRESCRIPTIONS);
  }, []);

  return <VideoConferenceNotificationsView
    pending={prescriptionFillsStore.pendingArray}
    onClick={goToReview}
  />;
};

export default observer(UnroutedPrescriptionsNotificationsContainer);
